<template>
  <div class="thumbnail-cropper-wrapper">
    <div class="thumbnail-cropper-container" :hidden="isEmpty(b64Img)">
      <input
        ref="thumbnailFileInput"
        style="display: none"
        type="file"
        name="image"
        accept="image/*"
        @change="setImage"
      />
      <vue-cropper
        class="img-fluid brad-3"
        ref="cropper"
        :viewMode="2"
        dragMode="crop"
        :background="true"
        :src="thumbnail"
        alt="Source Image"
        :aspectRatio="16 / 9"
        :img-style="{ width: '100%', height: 'auto' }"
      >
      </vue-cropper>
      <b-button variant="primary" type="button" @click="cropImage"  class="float-right mt-2">{{
        $t('vignette.confirm')
      }}</b-button>
    </div>
    <div class="thumbnail-container" :hidden="thumbnail === '' || b64Img !== ''">
      <img :src="thumbnail" class="img-fluid brad-3" alt="Cropped Image" fill-width />
      <div class="more-btn-container">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <span v-if="!hasSkin" class="icon-more"></span>
            <div v-if="hasSkin" class="settings-button">
              <span class="icon-settings"></span>
            </div>
          </template>
          <b-dropdown-item @click="updateThumbnail()">
            <span class="icon-edit"></span>
            {{ $t('vignette.edit') }}
          </b-dropdown-item>
          <b-dropdown-item @click="removeThumbnail()" :disabled="isEmpty(imgUrl)">
            <span class="icon-trash"></span>
            {{ $t('vignette.delete') }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import {  mapGetters } from 'vuex';

import UploadMixin from '../../mixins/UploadMixin.js';
import i18n from '../../i18n/index.js';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import NProgress from 'nprogress';

export default {
  name: 'ThumbnailCropper',
  mixins: [UploadMixin],
  components: {
    VueCropper,
  },
  data() {
    return {
      b64Img: '',
      imgUrl: '',
      isDefault:false,
      isEditingThumbnail:false,
      confirmClicked:false
    };
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  props: {
    cropImg: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      defaultThumbnail: 'common/getDefaultThumbnail',
    }),
     thumbnail() {
       let defaultTumbnail =process.env.BASE_HREF+"liste-lives/static/vignette/vignette_purple.jpg";
       if (this.hasISFM) {
         defaultTumbnail=process.env.BASE_HREF+"liste-lives/static/vignette/vignette_green.jpeg";
       }
       if(this.defaultThumbnail && this.defaultThumbnail!==null && this.defaultThumbnail!=='' && this.defaultThumbnail!==undefined){
         defaultTumbnail =process.env.BASE_HREF+"liste-lives/static/vignette/"+this.defaultThumbnail;
       }
      return this.imgUrl || defaultTumbnail;
    },
    hasSkin() {
      if(window.process.env.HAS_SKIN === 'true') {
        return true;
      } else {
        return false;
      }
    },
    hasISFM() {
      if(window.process.env.ISFM && window.process.env.ISFM !=="false" ) {
        return true;
      } else {
        return false;
      }
    },
    getClientName1() {
      return window.process.env.CLIENT_NAME1;
    },
    getClientName2() {
      return window.process.env.CLIENT_NAME2;
    },
  },
  watch: {
    cropImg() {
      if (!this.imgUrl) {
        this.imgUrl = this.cropImg;
      }
    },
  },
  methods: {
      toDataURL(url, callback) {
          var xhr = new XMLHttpRequest();
          xhr.onload = function() {
              var reader = new FileReader();
              reader.onloadend = function() {
                  callback(reader.result);
              }
              reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
      },

      async b64toBlob (b64Data, contentType='', sliceSize=512) {
          const byteCharacters = atob(b64Data);
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
              const slice = byteCharacters.slice(offset, offset + sliceSize);

              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                  byteNumbers[i] = slice.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
          }

          const blob = new Blob(byteArrays, {type: contentType});
          return blob;
      },
    isEmpty(img) {
      if (!img) {
        return true;
      }
      if (typeof img === 'object') {
        return Object.keys(img).length === 0;
      }
      return img === '';
    },
    setImage(e) {
  const file = e.target.files[0];
  if (!file) return;
  if (!file.type.includes('image/')) {
    alert('Veuillez sélectionner un fichier image');
    return;
  }

  const reader = new FileReader();
  reader.onload = event => {
    this.b64Img = event.target.result;
    this.$refs.cropper.replace(event.target.result);
    this.$refs.thumbnailFileInput.value = '';

    this.isEditingThumbnail = true;
    this.$emit('pickedImage', file); // ⭐ emit raw file if needed
  };
  reader.readAsDataURL(file);
},
    cropImage() {
  NProgress.start();
  const width = 1280;
  const height = Math.round(width * 9 / 16);

  const canvas = this.$refs.cropper.getCroppedCanvas({ width, height });

  // Keep base64 for preview
  this.imgUrl = canvas.toDataURL();

  // Convert canvas to Blob and File
  canvas.toBlob(blob => {
    if (!blob) return;

    const file = new File([blob], 'thumbnail.jpg', { type: 'image/jpeg' });

    // Emit file to parent
    this.$emit('thumbnailUpdated', file);

    this.isEditingThumbnail = false;
    this.$emit('thumbnailConfirmed', this.confirmClicked);

    NProgress.done();
  }, 'image/jpeg', 0.9);

  this.b64Img = '';
},
    updateThumbnail() {
      this.$refs.thumbnailFileInput.click();
    },
    removeThumbnail() {
      NProgress.start()
      this.imgUrl = '';
      this.$refs.thumbnailFileInput.value = '';
      this.$emit('thumbnailUpdated', '');
    },
  },
  mounted() {
    if (this.cropImg) {
    this.imgUrl = this.cropImg;
  }
  },
};
</script>

<style scoped lang="scss">
@import '~styles/theme';
.thumbnail-cropper-wrapper {
  .thumbnail-container {
    position: relative;
    .more-btn-container {
      position: absolute;
      right: 0;
      top: 0;
      ::v-deep .btn {
        color: #ffffff;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
        padding-top: 0.5em;
      }
      ::v-deep .dropdown-menu {
        transform: translate3d(-90px, 35px, 0px) !important;
        padding: 2px 0;
        min-width: 120px;
        .dropdown-item {
          padding: 2px 8px;
          &:active,
          .active,
          &:hover {
            color: #fff;
            background-color: var(--primary-color, $primary-color) !important;
            border-color: var(--primary-color, $primary-color) !important;
          }
        }
      }
      .settings-button {
        padding: 0.3em 0.3em;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        background-color: rgba(93, 93, 95, 0.5);
      }
    }
    .thumbnail-wrapper {
      display: flex;
      flex-direction: column;
      color: white;
      position: absolute;
      top: 0;
      justify-content: center;
      align-items: center;
      bottom: 0;
      right: 0;
      left: 0;
      .client-name {
        font-size: 2em;
        font-weight: 700;
          line-height: 40px;
        .logo-part2 {
          color: var(--secondary-color, grey);
        }
      }
      .streaming {
        font-size: 1.2em;
      }
      .live-icon-button {
        font-size: 2.5em;
        padding-bottom: 0.2em 0;
      }
    }
  }
  .thumbnail-cropper-container {
    .float-right.btn.btn-primary {
      color: #fff;
      background-color: var(--primary-color, $primary-color) !important;
      border-color: var(--primary-color, $primary-color) !important;
      box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
        0 1px 1px var(--primary-color, $primary-color) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/ThumbnailCropper.vue